import Button from '@loggi/ui/components/button';
import Col from '@loggi/ui/components/col';
import Text from '@loggi/ui/components/text';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './address-complement.styles.scss';

export default class AddressComplement extends Component {
  static displayName = 'AddressComplement';

  static propTypes = {
    complement: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    buttonValue: PropTypes.string.isRequired
  };

  static defaultProps = {
    complement: ''
  };

  constructor(props) {
    super(props);
    this._onChange = this._onChange.bind(this);
    this._onClick = this._onClick.bind(this);

    this.state = {
      complement: props.complement
    };
  }

  _onSelect = e => {
    const newComplement = e.target.value;
    if (newComplement === 'Sem Complemento') {
      this.setState({ complement: '' });
    }
  };

  _onChange(e) {
    const newComplement = e.target.value;
    this.setState({ complement: newComplement });
  }

  _onClick() {
    const { onClick } = this.props;
    const { complement } = this.state;
    return onClick(complement);
  }

  render() {
    const { buttonValue } = this.props;
    const { complement } = this.state;
    return (
      <Col
        size={12}
        flexDirection="row"
        justifyContent="between"
        alignItems="center"
        gutter={{
          top: 'half',
          left: 'normal',
          right: 'normal',
          bottom: 'half'
        }}
      >
        <Col gutter={{ bottom: 'half', right: 'normal' }} flexGrow="1">
          <Text bold small color="medium">
            Complemento
          </Text>
          <input
            data-hj-whitelist
            data-testid="complement"
            className={styles.customInput}
            type="text"
            value={complement}
            onSelect={this._onSelect}
            onChange={this._onChange}
            disabled={buttonValue === 'Alterar'}
          />
        </Col>
        <Button
          data-testid="on-click-confirm-new-address"
          className={`btn-small ${styles.customButton}`}
          shape="rounded"
          style="outline"
          value={buttonValue}
          size="regular"
          onClick={this._onClick}
        />
      </Col>
    );
  }
}
